import React from 'react';
import Modal from 'react-bootstrap/Modal';

function TextModal({ show, onHide, title, content }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby={`${title.toLowerCase().replace(/\s+/g, '-')}-modal`}
      className="text-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id={`${title.toLowerCase().replace(/\s+/g, '-')}-modal`}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          {content || `No ${title.toLowerCase()} available`}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default TextModal;

